import * as React from 'react';
import classNames from 'classnames';
import './styles.scss';

export interface IBlockProps {
    /** className to append */
    className?: string;
    /** className to append to innerContainer */
    innerClassName?: string;
    /** Theme to use */
    theme?: 'lightest' | 'lighter' |'light' | 'dark' | 'darker' | 'darkest' | 'success' | 'danger' | 'warning';
    /** Toggle rendering */
    visible?: boolean;
}

interface IState {

}

/**
 * Basic container block for paddings and background color.
 */
class Block extends React.Component<IBlockProps, IState> {
    static displayName: string = 'Block';

    render () {
        if (this.props.visible === false) {
            return null;
        }
        return (
            <div className={classNames('block', {
                'theme-lightest': this.props.theme === 'lightest',
                'theme-lighter': this.props.theme === 'lighter',
                'theme-light': this.props.theme === 'light',
                'theme-default': !this.props.theme,
                'theme-dark': this.props.theme === 'dark',
                'theme-darker': this.props.theme === 'darker',
                'theme-darkest': this.props.theme === 'darkest',
                'theme-success': this.props.theme === 'success',
                'theme-danger': this.props.theme === 'danger',
                'theme-warning': this.props.theme === 'warning',
            }, this.props.className)}>
                <div className={classNames('block-limiter', this.props.innerClassName)}>
                    {this.props.children}
                </div>
            </div>
        );
    }
}

export default Block;
